export const ENVIRONMENTS = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production'
};

export const SENTRY_ENVIRONMENTS = {
  TEST: 'test',
  PRODUCTION: 'prod'
};

export const SENTRY_REPLAY_ENVS = [SENTRY_ENVIRONMENTS.PRODUCTION, SENTRY_ENVIRONMENTS.TEST];

export const VALID_SENTRY_ENVS = Object.values(SENTRY_ENVIRONMENTS);
